import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

// crumbs: [{ label, to? }]
export default function Breadcrumbs({ crumbs = [] }) {
  return (
    <nav aria-label="Breadcrumb" data-testid="breadcrumbs" className="flex items-center flex-wrap gap-1 text-sm text-greyish">
      <Link to="/" className="hover:text-aqua transition-colors">Home</Link>
      {crumbs.map((c, i) => (
        <span key={i} className="flex items-center gap-1">
          <ChevronRight className="w-3.5 h-3.5 text-greyish/50" />
          {c.to && i < crumbs.length - 1 ? (
            <Link to={c.to} className="hover:text-aqua transition-colors">{c.label}</Link>
          ) : (
            <span className="text-ink font-medium">{c.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}
